// Summary metric tile (ready / exists / error counts). Colour keyed to the semantic status.
export function Stat({
  label,
  value,
  color,
}: {
  label: string;
  value: number;
  color: "green" | "amber" | "red";
}) {
  // Brand status tokens (not Tailwind default scales): keeps the import flow in lockstep
  // with the rest of the dashboard, which colours status with green-bg/warning/red-bg.
  const colors = {
    green: "bg-green-bg text-green-dark",
    amber: "bg-warning-bg text-warning",
    red: "bg-red-bg text-red",
  };
  return (
    <div className={`rounded-card p-3 text-center ${colors[color]}`}>
      <div className="text-[22px] font-bold tnum">{value}</div>
      <div className="text-[12px] font-medium">{label}</div>
    </div>
  );
}
